import editor from "./editor";
import commonHelpers from "common/plugins/issues/or";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
